export const API_DEV_URL = 'https://api.karmalinks.io';
export const API_URL = 'https://api.karmalinks.io';

export const EMAIL_DOMAIN_STATUS = {
  COMPANY: 'COMPANY',
};

export const LOCAL_STORAGE = {
  CURRENT_DOMAIN_VALIDATION: 'CURRENT_DOMAIN_VALIDATION',
  INFO_RESPONSIVITY: 'INFO_RESPONSIVITY',
  INVITE_CLOSED: 'INVITE_CLOSED',
};

export const CRISP_WEBSITE_ID_PERS = 'bea2794c-105c-469d-9a50-07179561f09e';

export const BACKLINK_REQUEST_STATUS = {
  ACCEPTED: 'ACCEPTED',
  PENDING: 'PENDING',
  LIVE: 'LIVE',
  WARNING: 'WARNING',
  LOST: 'LOST',
  EXPIRED: 'EXPIRED',
  TAX: 'TAX',
};

export const REQUEST_TYPE = {
  GIVE: 'GIVE',
  ASK: 'RECEIVE',
};

export const MAX_CONCURRENT_REQUESTS = 2;
export const MAX_DAYS_TO_ANSWER = 14;
export const GA_MEASUREMENT_ID = 'G-Y5VXHL3J53';
export const SESSION_VISION_KEY = 'sv_pub_3CbpOJ9ek-hx7FJWHGI_chpdk5o93MT0q6PZaypMSB8';

export const ANALYTICS_EVENTS = {
  SIGNUP: 'SIGNUP',
};

export const BUY_POINTS_URL = 'https://buy.stripe.com/5kQbJ1gew7UV2Jc3pxawo00';
export const JOINING_FEE_URL = 'https://buy.stripe.com/dRm9ATaUcgrrfvYgcjawo01';

export const ROLLBAR_ACCESS_TOKEN = 'aa4de9c9edad4529a2f9638ebf39b258';
